import React from 'react';
import LabelledValue from '../pages/portal/shared/LabelledValue';

export const PortfolioValuation = ({value, currency}) => <LabelledValue fullWidth align="right" label={`Portfolio Valuation (${currency && currency})`} value={value && value} />;
export const CashBalance = ({value, currency}) => <LabelledValue fullWidth align="right" label={`Total Cash Balance (${currency && currency})`} value={value && value} />;